import React from 'react';

const variants = {
  primary: 'bg-terra-400 text-white hover:bg-terra-500 shadow-card hover:shadow-hover',
  secondary: 'bg-white text-ink-700 border border-sand-200 hover:bg-sand-100 hover:border-sand-300',
  ghost: 'bg-transparent text-terra-400 hover:bg-sand-100',
  danger: 'bg-uae-red/10 text-uae-red hover:bg-uae-red/20',
};

const sizes = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-5 py-2.5 text-sm',
  lg: 'px-6 py-3 text-base',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className = '',
  ...props
}) {
  const isDisabled = disabled || loading;
  return (
    <button
      disabled={isDisabled}
      className={[
        'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-all duration-200',
        variants[variant],
        sizes[size],
        isDisabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer',
        className,
      ].join(' ')}
      {...props}
    >
      {loading ? (
        <>
          <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
          {children}
        </>
      ) : children}
    </button>
  );
}
